import { api } from "./api";
import store from "../store";

export async function atualizarLogNegoc(body) {
    try {
        // Acessa o Vuex: Despacha uma action ou faz commit em uma mutation
        await store.dispatch('insereLogNegoc', body)

        await api.post("Logs/inserelognegoc", body);

        // Exemplo de leitura direta do state se necessário:
        // console.log('Estado atualizado no Vuex:', store.state.logNegoc)

    } catch (erro) {
        console.error('Erro no fluxo:')
    }
}